import { ActionTypes } from "../type";

const initialState ={
    designation:null
}

export const designationReducer = (state=initialState,action)=>{
    switch (action.type){
        case ActionTypes.DESIGNATION:
            return {...state,designation:action.payload}
        default:
            return state;
    }
}